import { render } from "./jinnah-feedback.vue?vue&type=template&id=8ff6b6bc&scoped=true"
import script from "./jinnah-feedback.vue?vue&type=script&lang=js"
export * from "./jinnah-feedback.vue?vue&type=script&lang=js"

import "./jinnah-feedback.vue?vue&type=style&index=0&id=8ff6b6bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ff6b6bc"]])

export default __exports__